import styled from 'styled-components/native'

export const ListContainer = styled.View`
    margin-left: auto;
    margin-right: auto;
    min-width: 80%;
`
